"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VIDEO_SLIDE = exports.PLAY_PLAY_SIZE = exports.PLAY_CIRCLE_SIZE = exports.NAVIGATION_MOBILE_HEIGHT = exports.MEDIA_CAROUSEL_PAGINATION_STEP_DEFAULT_SIZE = exports.MEDIA_CAROUSEL_PAGINATION_STEP_ACTIVE_SIZE = exports.MEDIA_CAROUSEL_PAGINATION_STEP = exports.MEDIA_CAROUSEL = exports.IMAGE_SLIDE = exports.ACTIVE_PLAY_PLAY_SIZE = exports.ACTIVE_PLAY_CIRCLE_SIZE = void 0;
const MEDIA_CAROUSEL = exports.MEDIA_CAROUSEL = 'media-carousel';
const MEDIA_CAROUSEL_PAGINATION_STEP = exports.MEDIA_CAROUSEL_PAGINATION_STEP = 'media-carousel-pagination-step';
const IMAGE_SLIDE = exports.IMAGE_SLIDE = 'image-slide';
const VIDEO_SLIDE = exports.VIDEO_SLIDE = 'video-slide';
const MEDIA_CAROUSEL_PAGINATION_STEP_DEFAULT_SIZE = exports.MEDIA_CAROUSEL_PAGINATION_STEP_DEFAULT_SIZE = 30;
const MEDIA_CAROUSEL_PAGINATION_STEP_ACTIVE_SIZE = exports.MEDIA_CAROUSEL_PAGINATION_STEP_ACTIVE_SIZE = 40;
const PLAY_CIRCLE_SIZE = exports.PLAY_CIRCLE_SIZE = 12;
const PLAY_PLAY_SIZE = exports.PLAY_PLAY_SIZE = 6;
const ACTIVE_PLAY_CIRCLE_SIZE = exports.ACTIVE_PLAY_CIRCLE_SIZE = 18;
const ACTIVE_PLAY_PLAY_SIZE = exports.ACTIVE_PLAY_PLAY_SIZE = 9;
const NAVIGATION_MOBILE_HEIGHT = exports.NAVIGATION_MOBILE_HEIGHT = '75px';
//# sourceMappingURL=constants.js.map